import React, { Component } from 'react'
import { connect } from 'react-redux'
import ConfirmDialog from 'components/ConfirmDialog'
import { last, isEmpty } from 'lodash'
import { submitDialog, cancelDialog } from 'actions/dialog'

class ConfirmDialogContainer extends Component {
  render () {
    const {
      dialog,
      onSubmit,
      onCancel
    } = this.props

    return (
      <ConfirmDialog
        isOpened={!isEmpty(dialog)}
        onSubmit={onSubmit}
        onCancel={onCancel}
        message={dialog.message}
        submitMessage={dialog.submitMessage}
        cancelMessage={dialog.cancelMessage}
        title={dialog.title}
      />
    )
  }
}

function mapStateToProps (state) {
  const dialog = last(state.dialog)
  return {
    dialog: dialog || {}
  }
}

function mapDispatchToProps (dispatch) {
  return {
    submit: (id) => dispatch(submitDialog(id)),
    cancel: (id) => dispatch(cancelDialog(id))
  }
}

function mergeProps (stateProps, dispatchProps, ownProps) {
  const { dialog } = stateProps
  const { submit, cancel } = dispatchProps
  return {
    dialog,
    onSubmit: () => submit(dialog.id),
    onCancel: () => cancel(dialog.id)
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ConfirmDialogContainer)
